<template>
  <div class="signin-history">
    <v-data-table
      :server-items-length="getTotalItems"
      :headers="headers"
      :items="items"
      :items-per-page="itemsPerPage"
      :footer-props="{
        itemsPerPageOptions: [itemsPerPage]
      }"
      @update:page="pageChanged"
    >
      <template v-slot:item.customer="{ item }">
        {{ item.user.customer.name }}
      </template>

      <template v-slot:item.user="{ item }">
        {{ item.user.email }}
      </template>

      <template v-slot:item.timestamp="{ item }">
        {{ item.timestamp }}
      </template>

    </v-data-table>
  </div>
</template>

<script>
import * as dayjs from 'dayjs';

export default {
  name: 'AppUsage',
  data() {
    return {
      headers: [
        { text: 'Customer', value: 'customer', sortable: false },
        { text: 'User', value: 'user', sortable: false },
        { text: 'Ip address', value: 'idaddress', sortable: false },
        { text: 'Timestamp', value: 'timestamp', sortable: false },
      ],
      objects: [],
      itemsPerPage: 100,
      totalItems: 0,
    };
  },
  computed: {
    items() {
      this.objects.forEach((el) => {
        const element = el;
        element.timestamp = dayjs(el.timestamp).format('DD/MMM/YYYY HH:mm:ss');
      });
      return this.objects;
    },
    getTotalItems() {
      return this.totalItems;
    },
  },
  methods: {
    pageChanged(page) {
      this.getHistoryItems(page);
    },
    getHistoryItems(page) {
      this.$http.get(`api/signin_histories?page=${page}&order[timestamp]=desc`, {
        headers: {
          Accept: 'application/ld+json',
        },
      }).then((data) => {
        this.objects = data.data['hydra:member'];
        this.totalItems = data.data['hydra:totalItems'];
      });
    },
  },
  created() {
    this.getHistoryItems(1);
  },
};
</script>

<style scoped>

</style>
